<template>
  <div class="multimedia__content-grid">
    <chat-multimedia-empty v-if="elements.length === 0" tab="''" />
    <div v-else class="grid-x grid-margin-x grid-margin-y">
      <div
        v-for="(item, index) in elements"
        :key="`custom-${index}`"
        class="cell small-12 medium-6"
      >
        <items-custom-file
          :label="item.label"
          :accept="item.accept"
          :type="item.type"
          @file-selected="fileSelected"
        >
          <component :is="item.icon" />
        </items-custom-file>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ItemsCustomFile from '@/components/multimedia/items/CustomFile.vue';
import TypeAudioIcon from '@/assets/icons/type-audio.svg';
import TypeDocumentIcon from '@/assets/icons/type-document.svg';
import TypeImageIcon from '@/assets/icons/type-image.svg';

export default {
  components: {
    ItemsCustomFile,
    TypeAudioIcon,
    TypeDocumentIcon,
    TypeImageIcon,
    ChatMultimediaEmpty: () => import('@/components/ChatMultimediaEmpty.vue'),
  },
  data() {
    return {
      imageAcceptedTypes: [
        'image/gif',
        'image/jpeg',
        'image/png',
      ],
      documentAcceptedTypes: [
        'text/plain',
        'text/rtf',
        'application/pdf',
        'application/msword',
        'application/vnd.ms-excel',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ],
      audioAcceptedTypes: [
        'audio/*',
      ],
    };
  },
  computed: {
    ...mapGetters([
      'activeConversation',
      'activeConversationHistory',
      'getConfig',
    ]),
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    campaign() {
      return this.conversation.campaign ?? {};
    },
    channel() {
      return this.conversation.channel ?? {};
    },
    campaignId() {
      return this.campaign.id ?? null;
    },
    channelId() {
      return this.channel.id ?? null;
    },
    configuration() {
      return this.getConfig(this.campaignId, this.channelId);
    },
    customAudio() {
      return this.configuration.customAudio ?? false;
    },
    customDocuments() {
      return this.configuration.customDocuments ?? false;
    },
    customImages() {
      return this.configuration.customImages ?? false;
    },
    elements() {
      const options = [];

      if (this.customImages) {
        options.push({
          label: this.$t('multimedia.image'),
          accept: this.imageAcceptedTypes.join(','),
          icon: 'type-image-icon',
          type: 'image',
        });
      }

      if (this.customDocuments) {
        options.push({
          label: this.$t('multimedia.document'),
          accept: this.documentAcceptedTypes.join(','),
          icon: 'type-document-icon',
          type: 'document',
        });
      }

      if (this.customAudio) {
        options.push({
          label: 'Audio',
          accept: this.audioAcceptedTypes.join(','),
          icon: 'type-audio-icon',
          type: 'audio',
        });
      }

      return options;
    },
  },
  methods: {
    fileSelected(multimedia, type) {
      this.$emit('multimedia-picked', {
        multimedia,
        type,
      });
    },
  },
};
</script>
